import {
  EducationalContent,
  EducationalSection,
  Introduction
} from '@com-delta-idp/mnx-skymiles-educational-content-ui';
import {
  AEMErrorMessage,
  getEmptyContent,
  getGenericLabel,
  getImage,
  getLink,
  isValidData
} from '@com-delta-idp/mnx-skymiles-shared';
import { logError } from '@com-delta-idp/mnx-utils';
import { MediaCard } from '@com-delta-omnichannel/aura';
import {
  AEMEducationalContent,
  Details,
  EducationalModal,
  GalleryContent
} from '../models/educational-content-aem.interfaces';
import { getItems } from '../utils/educational-content.utils';

export const getEducationalContent = (
  aem: AEMEducationalContent | undefined,
  error: string | undefined,
  aemErrorMessages: AEMErrorMessage[] | undefined
): EducationalContent => {
  try {
    if (error) {
      return getEmptyContent<EducationalContent>(error, aemErrorMessages, true);
    }
    return isValidData<
      AEMEducationalContent,
      [AEMEducationalContent | undefined]
    >('educationalModal', aem)
      ? adaptEducationalContentObject(aem as AEMEducationalContent)
      : getEmptyContent<EducationalContent>();
  } catch (error) {
    logError(
      error as Error,
      'SKYMILES',
      'EDUCATIONAL_CONTENT',
      'EDUCATIONAL_CONTENT_PAGE'
    );
    return getEmptyContent<EducationalContent>('', [], true, true);
  }
};

const adaptEducationalContentObject = (
  aem: AEMEducationalContent
): EducationalContent => {
  const content = aem.educationalModal;
  const data = {
    title: content.title,
    introduction: getIntroduction(content),
    sections: getSections(content),
    disabled: false,
    loaded: true
  };
  return data;
};

const getIntroduction = (content: EducationalModal): Introduction => {
  return {
    header: {
      title: content.header.title,
      content: content.header.subtitle
    },
    requirements: {
      header: getGenericLabel(
        content.header.details.title,
        content.header.details.subtitle
      ),
      items: getItem(content.header.details)
    },
    note: content.header.details.headerNote
  };
};

const getItem = (content: Details): MediaCard[] => {
  const mediaCards: MediaCard[] = [];
  let itemsObject = {} as MediaCard;
  content.gallery.forEach((item: GalleryContent) => {
    itemsObject = {
      image: getImage(item.imageSrc, item.imageAlt),
      label: getGenericLabel(item.mediaTitle, item.mediaValue)
    };
    mediaCards.push(itemsObject);
  });
  return mediaCards;
};

const getSections = (content: EducationalModal): EducationalSection[] => {
  const section: EducationalSection[] = [];
  let ways = {} as EducationalSection;
  let benefits = {} as EducationalSection;
  ways = {
    header: getGenericLabel(content.earnStatus.title, ''),
    items: getItems(content.earnStatus.earnItems),
    action: getLink(
      content.earnStatus.actionLabel,
      content.earnStatus.actionUrl
    ),
    note: content.earnStatus.earnNote
  };
  section.push(ways);
  benefits = {
    header: getGenericLabel(content.benefits.title, content.benefits.subtitle),
    items: getItems(content.benefits.avails),
    action: getLink(content.benefits.actionLabel, content.benefits.actionUrl)
  };
  section.push(benefits);
  return section;
};
